import classNames from 'classnames';
import * as React from 'react';
const Link = (props) => {
    const { children, className, href, target, ...rest } = props;
    const classes = classNames('ixu-link', className);
    const HTMLTag = href ? 'a' : 'button';
    const targetAttributes = {};
    if (href && target) {
        targetAttributes.target = target;
        if (target === '_blank') {
            targetAttributes.rel = 'nofollow noreferrer';
        }
    }
    return (React.createElement(HTMLTag, { ...rest, ...targetAttributes, className: classes, href: !!href ? href : undefined }, children));
};
export default Link;
//# sourceMappingURL=Link.js.map